import DeleteIcon from "@mui/icons-material/PersonRemove";
import { IconButton, Tooltip } from "@mui/material";

import { RoleType, User } from "./Users";

export default function DeleteUserAction<T extends RoleType>(params: {
  data: User<T>;
  handleUserDeleteRequest: (userName: string) => void;
  solutionName?: string;
  myUserName?: string;
  disabled?: boolean;
}) {
  const {
    data: { name: userName, firstName, lastName },
    handleUserDeleteRequest,
    solutionName,
    myUserName,
    disabled
  } = params;

  const isDisabled = disabled || userName === myUserName;
  return (
    <Tooltip
      title={
        <>
          Remove
          <b>{` ${firstName} ${lastName} `}</b>
          {solutionName ? (
            <>
              from solution <b>{` ${solutionName} `}</b>
            </>
          ) : null}
        </>
      }
    >
      <span>
        <IconButton
          data-testid="delete-user"
          onClick={() => {
            handleUserDeleteRequest(userName);
          }}
          size="large"
          disabled={isDisabled}
        >
          <DeleteIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
}
